export enum Status {
  success = "Success",
  failure = "Failure",
}
